export default "/images/b3fcf17a669eea44e7450262082e45ff.avif";